import { Autocomplete, Checkbox, Divider, Grid, TextField, Typography, useMediaQuery } from '@mui/material';
import style from "../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import datePickerStyles from "../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisAudio.module.scss";
import feedbackStyles from "../../../assets/styles/componentStyles/feedbackStyles/feedbackStyle.module.scss"; 
import React, { useContext, useState } from 'react'
import { campaignContactData, campaignContactTagAssignment } from '../../../models/axiosModel';
import GlobalButton from '../../utility/globalButton/button';
import { filtersInterface, nameData } from './contactList';
import { DateRangePicker, FocusedInputShape } from 'react-dates';
import DatePresets from '../callAnalysis/datePresets';
import moment, { Moment } from 'moment';
import { getCustomTagOption, isArchivedContactList, isMasterContactList } from './contactConstant';
import { ContactContext, ContactContextPayload } from '../../../context/contactContext';
import { useGenericStore } from '../../../store/genericStore';
import { flagAddTagDialogObj } from './contactsGlobal';
import { filterAutocompleteOptionsWithException } from '../../../utils/constants';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import RenderCustomOption from '../../global/autocomplete/renderCustomOption';


interface ContactFilterPopupProps {
    setFlagFilterDialog: React.Dispatch<React.SetStateAction<boolean>>,
    phoneNumberData: campaignContactData[],
    nameData: nameData[],
    tagData: campaignContactTagAssignment[],
    filters: filtersInterface,
    setFilters: React.Dispatch<React.SetStateAction<filtersInterface>>,
    handleClearFilter: () => void,
    setFlagAddTagDialogObj: React.Dispatch<React.SetStateAction<flagAddTagDialogObj>>,
}

const ContactFilterPopup: React.FC<ContactFilterPopupProps> = ({ setFlagFilterDialog, phoneNumberData, nameData, tagData, filters, setFilters, handleClearFilter, setFlagAddTagDialogObj }) => {

    const [filtersInPopup, setFiltersInPopup] = useState<filtersInterface>(filters)
    const { campaignContactData } = useContext(ContactContext) as ContactContextPayload;
    const globalStatusData = useGenericStore((state) => state.listOfChatbotStatus);
    const { userDetail, apiRoutesPermissionAssignment } = useContext(UserContext) as UserContextPayload;

    const [focusedDateRangePickerInput, setFocusedDateRangePickerInput] = useState<FocusedInputShape | null>(null);
    const dateFormat = "DD-MMM-YYYY"; 
    const tabScreen = useMediaQuery("(max-width : 1000px) and (min-width : 0px)");

    const isContactListArchived = isArchivedContactList(campaignContactData?.[0], globalStatusData);

    const getTagOptions = () => {
        if(isContactListArchived) {
            return tagData ? tagData : []
        } else {
            return tagData ? [...(tagData), ...(getCustomTagOption(apiRoutesPermissionAssignment, userDetail))] : []
        }
    } 

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Grid container direction={"column"} justifyContent={"center"}>
                        <Grid item textAlign={"center"}>
                            <Typography className={style.popupTitleTypography}> Contact Filter</Typography>
                        </Grid>

                        <Divider className={style.popupTitleDivider} />

                        <Grid item>
                            <Grid container className={style.filterPopupBodyContainer} gap={2.5}>
                                <Grid item xs={12}>
                                    <Grid container gap={"12px"}>
                                        <Grid item xs={12}>
                                            <Typography className={style.popupFieldTypography}>Date</Typography>
                                        </Grid>

                                        <Grid item className={`${datePickerStyles.dateRangePickerClass} ${feedbackStyles.dateRangePickerClass} ${style.dateRangePickerClass}`} >
                                            <DateRangePicker
                                                startDate={filtersInPopup.startDate}
                                                startDateId='s_id'
                                                endDate={filtersInPopup.endDate}
                                                endDateId='e_id'
                                                readOnly
                                                onDatesChange={({ startDate, endDate }) => {
                                                    if (startDate != filtersInPopup.startDate) {
                                                        endDate = null;
                                                    }
                                                    setFiltersInPopup((prev) => ({
                                                        ...prev,
                                                        startDate: startDate,
                                                        endDate: endDate,
                                                    }))
                                                }}
                                                focusedInput={focusedDateRangePickerInput}
                                                displayFormat={dateFormat}
                                                numberOfMonths={tabScreen ? 1 : 2}
                                                minimumNights={0}
                                                onFocusChange={(focusedDateRangePickerInput) => setFocusedDateRangePickerInput(focusedDateRangePickerInput)}
                                                isOutsideRange={(day) => day.isAfter(moment().endOf("day"))}
                                                onClose={({ startDate, endDate }) => {
                                                    if (startDate && !endDate) {
                                                        setFiltersInPopup((prev) => ({
                                                            ...prev,
                                                            endDate: moment(),
                                                        }));
                                                    }
                                                }}
                                                renderCalendarInfo={() => (
                                                    <DatePresets
                                                        startDate={filtersInPopup.startDate}
                                                        endDate={filtersInPopup.endDate}
                                                        dateFormat={dateFormat}
                                                        handlePresets={(start: Moment, end: Moment) => {
                                                            setFiltersInPopup((prev) => ({
                                                                ...prev,
                                                                startDate: start,
                                                                endDate: end,
                                                            }))
                                                            setFocusedDateRangePickerInput(null);
                                                        }}
                                                    />
                                                )}
                                            />
                                        </Grid>
                                    </Grid>   
                                </Grid>

                                <Grid item xs={12}>
                                    <Grid container gap={"12px"}>
                                        <Grid item xs={12}>
                                            <Typography className={style.popupFieldTypography}>Phone Number</Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Autocomplete
                                                className={`${style.contactFilterDropDowns} ${style.contactFilterDropdownsInPopup}`}
                                                // options={phoneNumberData}
                                                // getOptionLabel={(option) => option.contact_data_value}
                                                // value={phoneNumberData && phoneNumberData.length > 0 && phoneNumberData.filter((data) => selectedNumberData.some(number => number.contact_data_id === data.contact_data_id)) || []}
                                                // onChange={(_: React.SyntheticEvent, value: campaignContactData[]) => setSelectedNumberData(value)}
                                                options={phoneNumberData.map((phoneNumber) => phoneNumber.contact_data_value)}
                                                getOptionLabel={(option) => option}
                                                value={filtersInPopup.phoneNumber}
                                                multiple
                                                onChange={(_: React.SyntheticEvent, value: string[]) => {
                                                    setFiltersInPopup((prevState: any) => ({ ...prevState, phoneNumber: value }))
                                                }}
                                                ListboxProps={{
                                                    className: style.contactListAutoCompleteListBox,
                                                }}
                                                renderInput={params => {
                                                    const { InputProps, ...restParams } = params;
                                                    const { startAdornment, ...restInputProps } = InputProps;
                                                    return (
                                                        <TextField
                                                            {...restParams}
                                                            placeholder='Select Phone Number'
                                                            InputProps={{
                                                                ...restInputProps,
                                                                startAdornment: (
                                                                    <div style={{
                                                                        maxHeight: "90px",
                                                                        overflowY: 'auto',
                                                                    }}
                                                                    >
                                                                        {startAdornment}
                                                                    </div>
                                                                ),
                                                            }}
                                                        />
                                                    );
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12}>
                                    <Grid container gap={"12px"}>
                                        <Grid item xs={12}>
                                            <Typography className={style.popupFieldTypography}>Name</Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Autocomplete
                                                className={`${style.contactFilterDropDowns} ${style.contactFilterDropdownsInPopup}`}
                                                // options={nameData}
                                                // getOptionLabel={(option) => option.full_name}
                                                // value={nameData && nameData.length > 0 && nameData.filter((data) => selectedNameData.some(fullName => fullName === data)) || []}
                                                // onChange={(_: React.SyntheticEvent, value: nameData[]) => setSelectedNameData(value)}
                                                options={nameData.map((name) => name.first_name)}
                                                getOptionLabel={(option) => option}
                                                multiple
                                                value={filtersInPopup.name}
                                                onChange={(_: React.SyntheticEvent, value: string[]) => {
                                                    setFiltersInPopup((prev: any) => ({ ...prev, name: value }));
                                                }}
                                                ListboxProps={{
                                                    className: style.contactListAutoCompleteListBox,
                                                }}
                                                renderInput={params => {
                                                    const { InputProps, ...restParams } = params;
                                                    const { startAdornment, ...restInputProps } = InputProps;
                                                    return (
                                                        <TextField
                                                            {...restParams}
                                                            placeholder='Select Name'
                                                            InputProps={{
                                                                ...restInputProps,
                                                                startAdornment: (
                                                                    <div style={{
                                                                        maxHeight: "90px",
                                                                        overflowY: 'auto',
                                                                    }}
                                                                    >
                                                                        {startAdornment}
                                                                    </div>
                                                                ),
                                                            }}
                                                        />
                                                    );
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12}>
                                    <Grid container gap={"12px"}>
                                        <Grid item xs={12}>
                                            <Typography className={style.popupFieldTypography}>Tag</Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Autocomplete
                                                className={`${style.contactFilterDropDowns} ${style.contactFilterDropdownsInPopup}`}
                                                options={getTagOptions()}
                                                getOptionLabel={(option) => option.contact_tag_name || ''}
                                                isOptionEqualToValue={(option, value) => option.contact_tag_id === value.contact_tag_id}
                                                multiple
                                                value={tagData.filter((tag) => filtersInPopup.tags.includes(tag?.contact_tag_name || ""))}
                                                onChange={(_: React.SyntheticEvent, value: campaignContactTagAssignment[]) => {
                                                    setFiltersInPopup((prevState) => ({
                                                        ...prevState,
                                                        tags: value.map((tag) => tag?.contact_tag_name || ""),
                                                    }))
                                                }}
                                                renderOption={(props, option) => (
                                                    <RenderCustomOption
                                                        autocompleteRenderOptionProps={props}
                                                        option={option}
                                                        customOptionName={"New Tag"}
                                                        optionName={option.contact_tag_name}
                                                        optionLabelKey={'contact_tag_id'}
                                                        onClickOfCustomOption={() => setFlagAddTagDialogObj({ flag: true, flagFromEditContactDialog: false })}
                                                    />
                                                )}
                                                ListboxProps={{
                                                    className: style.contactListAutoCompleteListBox,
                                                }}
                                                filterOptions={(options, state) => filterAutocompleteOptionsWithException(options, state, "contact_tag_name", "contact_tag_id")}
                                                renderInput={params => {
                                                    const { InputProps, ...restParams } = params;
                                                    const { startAdornment, ...restInputProps } = InputProps;
                                                    return (
                                                        <TextField
                                                            {...restParams}
                                                            placeholder='Select Tag'
                                                            InputProps={{
                                                                ...restInputProps,
                                                                startAdornment: (
                                                                    <div style={{
                                                                        maxHeight: "90px",
                                                                        overflowY: 'auto',
                                                                    }}
                                                                    >
                                                                        {startAdornment}
                                                                    </div>
                                                                ),
                                                            }}
                                                        />
                                                    );
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {!isMasterContactList(campaignContactData?.[0]?.contact_list_name) && 
                                    <Grid item xs={12}>
                                        <Grid container gap={1} alignItems={'center'}>
                                            <Grid item>
                                                <Checkbox
                                                    checked={filtersInPopup?.includeDeletedContacts}
                                                    onChange={(e) => {
                                                        setFiltersInPopup((prev) => ({ ...prev, includeDeletedContacts: e.target.checked }))
                                                    }}
                                                    color="secondary"
                                                />
                                            </Grid>
                                            <Grid item>
                                                <Typography className={style.popupFieldTypography}>Include deleted contacts</Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }
                            </Grid>
                        </Grid>

                        <Grid item>
                            <Grid container justifyContent={"center"} alignItems={"center"} gap={"12px"} sx={{ padding: "35px 0" }}>
                                <Grid item>
                                    <GlobalButton
                                        buttonText="Clear"
                                        sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                        className='borderedButtonStyle'
                                        onClick={() => { handleClearFilter(); }}
                                    />
                                </Grid>
                                <Grid item>
                                    <GlobalButton
                                        buttonText="Apply Filter"
                                        sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                        className='primaryButtonStyle'
                                        onClick={() => { 
                                            const nextFilters = {
                                                ...filtersInPopup,
                                                endDate: filtersInPopup.startDate && !filtersInPopup.endDate ? moment() : filtersInPopup.endDate,
                                            };
                                              setFlagFilterDialog(false);
                                            setFilters(nextFilters);
                                            // filterCampaignContact(); 
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default ContactFilterPopup
